import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import Main from "../../../../layout/main/Main";
import { Space, Dropdown, Menu, Modal, Radio } from "antd";
import {
	ActionButton,
	AntdRadioButton,
	ButtonContainer,
	FilterContainer,
	Filters,
	RadioOptions,
} from "./styles";
import { COLORS, Typo } from "../../../../layout/theme";
import DataTable from "../../../../common/data-table/DataTable";
import debounce from "lodash/debounce";
import { BsThreeDotsVertical } from "react-icons/bs";
import LoadingHeader from "./components/LoadingHeader";
import HistoryModal from "./components/HistoryModal/HistoryModal";
import { useAuth } from "../../../../../contexts/authContext";
import {
	get_orders_requests,
	get_orders_requests_header_info,
} from "../../../../../api/endpoints/orders";
import AntdSearch from "../../../../common/antd-search/AntdSearch";
import TerciaryButton from "../../../../common/antd-buttons/TerciaryButton";

export default function MobileRequestList() {
	const { updateRequestValidation, setMobileRequestsQty } = useAuth();
	const [data, setData] = useState(null);
	const [state, setState] = useState("PENDING");
	const [key, setKey] = useState("null");
	const [headerInfo, setHeaderInfo] = useState(null);
	const [show, setShow] = useState(false);
	const [history, setHistory] = useState(null);
	const [loading, setLoading] = useState(false);

	const columns = [
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>LABORATORIO</div>
			),
			width: 180,
			dataIndex: "laboratoryName",
			render: (value, r) => (
				<Link
					to={`/admin/mobileRequests/${key.id}`}
					onMouseOver={() => setKey(r)}
				>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{value}
					</Typo>
				</Link>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>VENDEDOR</div>
			),
			width: 180,
			dataIndex: "sellerMobile",
			render: (value, record) => (
				<div
					style={{
						width: 180,
						whiteSpace: "nowrap",
						textOverflow: "ellipsis",
						overflow: "hidden",
					}}
				>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{value}
					</Typo>
				</div>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>
					PUNTO DE VENTA
				</div>
			),
			width: 200,
			dataIndex: "pointOfSaleName",
			render: (fila) => (
				<div
					style={{
						width: 200,
						whiteSpace: "nowrap",
						textOverflow: "ellipsis",
						overflow: "hidden",
					}}
				>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{fila}
					</Typo>
				</div>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>PROVINCIA</div>
			),
			dataIndex: "provinceName",
			render: (fila) => (
				<div
					style={{
						width: 100,
						whiteSpace: "nowrap",
						textOverflow: "ellipsis",
						overflow: "hidden",
					}}
				>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{fila}
					</Typo>
				</div>
			),
		},
		// {
		// 	title: () => (
		// 		<div style={{ color: COLORS.White, fontWeight: 700 }}>Localidad</div>
		// 	),
		// 	dataIndex: "localityName",
		// 	render: (fila) => (
		// 		<Typo type="darkGrey" fontWeight={600} fontSize={14}>
		// 			{fila}
		// 		</Typo>
		// 	),
		// },
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>TELEFONO</div>
			),
			dataIndex: "contactPhone",
			render: (fila) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					{fila}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>MAIL</div>
			),
			dataIndex: "contactEmail",
			render: (fila) => (
				<Typo type="secondary" fontWeight={700} fontSize={14}>
					{fila}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.White, fontWeight: 700 }}>#TRF</div>
			),
			dataIndex: "orderNumId",
			render: (fila, r) => (
				<Link
					to={`/admin/mobileRequests/${key.id}`}
					onMouseOver={() => setKey(r)}
				>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{fila}
					</Typo>
				</Link>
			),
		},
		{
			title: "",
			key: "id",
			dataIndex: "id",
			width: 30,
			render: (f, r, i) => (
				<>
					<Dropdown
						overlay={
							r.users[0].approved
								? r.deleted
									? menuRejected
									: menuApproved
								: r.deleted
									? menuRejected
									: menu
						}
						placement="bottomRight"
					>
						<ActionButton key={`${f}`} onMouseOver={() => setKey(r)}>
							<BsThreeDotsVertical color={COLORS.Secondary} />
						</ActionButton>
					</Dropdown>
				</>
			),
		},
	];

	const menu = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/mobileRequests/${key.id}`}>
							<Typo type="secondary">Editar</Typo>
						</Link>
					),
				},
			]}
		/>
	);

	const menuApproved = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/mobileRequests/${key.id}`}>
							<Typo type="secondary">Ver</Typo>
						</Link>
					),
				},
			]}
		/>
	);

	const menuRejected = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/mobileRequests/${key.id}`}>
							<Typo type="secondary">Ver</Typo>
						</Link>
					),
				},
			]}
		/>
	);

	const fetch_requests = async (page, state, search) => {
		try {
			setLoading(true);
			const res = await get_orders_requests(search, state, page);
			setData({
				...res,
				items: res.items?.map((r) => ({
					...r,
					orderNumId:
						r.orders[0]?.orderNumMobile > 0
							? r.orders[0]?.orderNumMobile
							: r.orders[0]?.orderNumId,
					laboratoryName: r.orders[0]?.seller.laboratory.name,
					sellerMobile:
						r.orders[0]?.seller.firstName + " " + r.orders[0]?.seller.lastName,
					pointOfSaleName: r.orders[0]?.pointOfSale?.name,
					localityName:
						r.orders[0]?.pointOfSale?.locality_Codes[0]?.locality?.title,
					provinceName:
						r.orders[0]?.pointOfSale?.locality_Codes[0]?.locality?.province[0]
							?.province?.title,
				})),
			});
		} catch (error) {
		} finally {
			setLoading(false);
		}
	};

	const fetch_requests_header = async () => {
		const res = await get_orders_requests_header_info();
		setHeaderInfo(res);
		setMobileRequestsQty(res.totalPending);
	};

	useEffect(() => {
		fetch_requests_header();
	}, [state]);

	useEffect(() => {
		fetch_requests(1, state, "");
	}, [state]);

	useEffect(() => {
		return () => {
			debouncedEventHandler.cancel();
		};
	}, []);

	const eventHandler = (e) => {
		fetch_requests(1, state, e.target.value);
	};

	const debouncedEventHandler = useMemo(() => debounce(eventHandler, 250), []);

	const handleOk = () => {
		setShow(false);
	};

	const handleCancel = () => {
		setShow(false);
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Solicitudes Mobile
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				{!headerInfo ? (
					<LoadingHeader />
				) : (
					<FilterContainer>
						<ButtonContainer>
							<TerciaryButton
								value="PENDING"
								onClick={(e) => setState("PENDING")}
							>
								Pendientes ({headerInfo?.totalPending})
							</TerciaryButton>
							<TerciaryButton
								value="APPROVED"
								onClick={(e) => setState("APPROVED")}
							>
								Aprobadas ({headerInfo?.totalApproved})
							</TerciaryButton>
							<TerciaryButton
								value="REJECTED"
								onClick={(e) => setState("REJECTED")}
							>
								Rechazadas ({headerInfo?.totalRejected})
							</TerciaryButton>
						</ButtonContainer>
						<AntdSearch
							width={400}
							allowClear
							placeholder="Buscar farmacia"
							onChange={debouncedEventHandler}
							style={{ borderRadius: 15, height: 40 }}
						/>
					</FilterContainer>
				)}
				<DataTable
					data={data}
					fetch={fetch_requests}
					columns={columns}
					loading={loading}
				/>
				<Modal
					open={show}
					onOk={handleOk}
					onCancel={handleCancel}
					width={900}
					centered={true}
					footer={null}
					destroyOnClose={true}
				>
					<HistoryModal client={key} history={history} />
				</Modal>
			</Main.Body>
		</Main>
	);
}
